export const faqLd = (faq) => ({
  "@type": "FAQPage",
  mainEntity: faq.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

export function Faq({ items, title = "Questions fréquentes", id = "faq" }) {
  if (!items?.length) return null;
  return (
    <section data-testid={`${id}-section`} className="mt-24 border-t border-[var(--line)] pt-16">
      <h2 className="font-display text-3xl sm:text-4xl">{title}</h2>
      <div className="mt-8 divide-y divide-[var(--line)] border-y border-[var(--line)]">
        {items.map((f, i) => (
          <details key={f.q} data-testid={`${id}-item-${i}`} className="group py-5">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-6 font-display text-xl italic">
              <h3>{f.q}</h3>
              <span className="text-2xl text-[var(--gold)] transition-transform duration-300 group-open:rotate-45" aria-hidden="true">+</span>
            </summary>
            <p className="mt-3 max-w-3xl text-sm leading-relaxed text-[var(--parchment)]/85 md:text-base">{f.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
